import type { Dictionary } from '../i18n.js';

export const shell: Dictionary = {
  // main.ts
  'Contacting the server…': 'Łączenie z serwerem…',
  'Building the city': 'Budowanie miasta',
  'Connected · {ms} ms': 'Połączono · {ms} ms',
  'Connecting…': 'Łączenie…',
  'Reconnecting… {detail}': 'Ponowne łączenie… {detail}',
  Offline: 'Offline',
  'Could not reach the game server ({error}). Is `npm run dev` running?':
    'Nie udało się połączyć z serwerem gry ({error}). Czy działa `npm run dev`?',
  'Could not load that tour. It may have been deleted.': 'Nie udało się wczytać turnieju. Możliwe, że został usunięty.',
  'Draw your own race': 'Narysuj własny wyścig',
  'Race here': 'Ścigaj się tutaj',
  'Adjust the race': 'Dopasuj wyścig',
  'Custom region': 'Własny obszar',
  'Finished! Waiting for the others…': 'Meta! Czekamy na resztę…',
  'Checkpoint {passed}/{total}': 'Punkt kontrolny {passed}/{total}',
  'Downloading the world…': 'Pobieranie świata…',
  'Building meshes…': 'Budowanie geometrii…',
  'it took too long': 'trwało to zbyt długo',
  'Could not load the world: {reason}': 'Nie udało się wczytać świata: {reason}',
  'World failed to load: {reason}. Rejoin the lobby to try again.':
    'Świat się nie wczytał: {reason}. Dołącz ponownie do lobby, żeby spróbować jeszcze raz.',
  'Next race — {title}': 'Następny wyścig — {title}',
  'End the tour': 'Zakończ turniej',
  'Back to lobby': 'Wróć do lobby',
  'Waiting for the host to start the next race…': 'Czekamy, aż gospodarz rozpocznie następny wyścig…',
  'Waiting for the host to start another race…': 'Czekamy, aż gospodarz rozpocznie kolejny wyścig…',
  'Leave race': 'Opuść wyścig',
  'Sound off': 'Dźwięk wyłączony',
  'Sound on': 'Dźwięk włączony',
  Respawned: 'Z powrotem na trasie',
  'Back on the street': 'Z powrotem na ulicy',
  'No gates and no clock. Drive anywhere; end it for everyone from the Esc menu.':
    'Bez bramek i bez zegara. Jedź, gdzie chcesz; zakończysz ją dla wszystkich w menu pod Esc.',
  'No gates and no clock. Drive anywhere; end it for everyone from the menu.':
    'Bez bramek i bez zegara. Jedź, gdzie chcesz; zakończysz ją dla wszystkich w menu.',
  'No gates and no clock. Drive anywhere; the host ends it.':
    'Bez bramek i bez zegara. Jedź, gdzie chcesz; zakończy ją gospodarz.',
  'End the free drive': 'Zakończ swobodną jazdę',
  'Aerial view': 'Widok z lotu ptaka',
  'Chase view': 'Widok zza auta',
  'Whole region': 'Cały obszar',
  'Following your car': 'Śledzenie auta',
  'Draw your own free drive': 'Narysuj własną swobodną jazdę',
  'Drive here': 'Jedź tutaj',
  'Loading the next map: {title}': 'Wczytywanie następnej mapy: {title}',
  'Next map: {title}': 'Następna mapa: {title}',
};
